import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function ProtectedRoute() {
  const { isAuth, loading } = useAuth();
  if (loading) return null; // or a spinner
  return isAuth ? <Outlet /> : <Navigate to="/login" replace />;
}
